import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { ThemeProps } from '../../../../styles/theme/app-theme';

export const InfoWrapper = styled.button(({ theme }: ThemeProps) => {
    return css`
        display: inline-flex;
        padding: 0;
        margin: 0;
        border: none;
        background: none;
        font: inherit;
        color: inherit;
        cursor: pointer;

        .info-icon {
            :hover {
                cursor: pointer;

                path {
                    fill: ${theme.app.blue02};
                }
            }
        }
    `;
});
